// Lógica compartida de poderes para la página de Asistentes y sus ventanas.
// Un poder vive en UNA fila (la de quien lo otorga) con rep_unidades = las
// unidades delegadas; un propietario con varias unidades puede repartirlas
// entre varios representantes.

export const nombreDe = (o) => (o ? [o.nombre, o.apellido].filter(Boolean).join(' ') : '');
// "101 · Torre 4": con varias torres, el número solo no identifica la unidad (F-14).
export const etiquetaUnidad = (row) => {
  const n = row?.unit?.numero_unidad, t = row?.unit?.building?.numero_torre;
  return n ? (t ? `${n} · ${t}` : n) : '';
};
export const coefDe   = (rows) => rows.reduce((s, r) => s + (parseFloat(r.unit?.coefficiente_votacion) || 0), 0);

// Map(unit_id -> fila del poder que la cubre)
export function poderesPorUnidad(items) {
  const m = new Map();
  items.filter(i => i.attendance_type === 'representative').forEach(p => {
    [...(p.rep_unidades || []), p.unit_id].map(Number).filter(Boolean).forEach(u => m.set(u, p));
  });
  return m;
}

// ¿Este poder es de este representante? (propietario: por documento; los
// poderes entre vecinos guardan el documento del representante)
export const esDelRepresentante = (poder, repDoc) =>
  !!poder && !poder.rep_es_externo && String(poder.rep_numero_documento) === String(repDoc);

// Propietarios de la asamblea agrupados, con sus filas ordenadas.
export function agruparPorPropietario(items) {
  const m = new Map();
  items.forEach(i => {
    if (!i.owner) return;
    if (!m.has(i.owner.id)) m.set(i.owner.id, { owner: i.owner, rows: [] });
    m.get(i.owner.id).rows.push(i);
  });
  return [...m.values()].map(g => ({ ...g, rows: g.rows.sort((a, b) => a.id - b.id) }));
}

// Coeficiente que un representante ya tiene por poderes registrados.
export function coefYaRepresentado(items, repDoc) {
  const porUnidad = poderesPorUnidad(items);
  return coefDe(items.filter(r => esDelRepresentante(porUnidad.get(Number(r.unit_id)), repDoc)));
}
